import React, { Component } from 'react';

import PropTypes from 'prop-types';

import { Redirect } from 'react-router-dom';

import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import CardActions from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import RestoreIcon from '@material-ui/icons/Restore';
import red from '@material-ui/core/colors/red';
import FavoriteIcon from '@material-ui/icons/Favorite';
import ShareIcon from '@material-ui/icons/Share';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import LocationOnIcon from '@material-ui/icons/LocationOn';

import { Tooltip } from '@material-ui/core';
import { eventsRef,paymentsRef } from '../../firebase';
const styles = theme => ({
    title: {
        paddingLeft: '80px',
        paddingRight: '80px',
        paddingTop: '35px',
    },
    card: {
        marginTop: "10px",
        width: "100%",
        margin: "25px 0",
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.14)",
        borderRadius: "3px",
        color: "rgba(0, 0, 0, 0.87)",
        background: "#fff",
         maxWidth: 400
    },
     menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
    media: {
    height: 0,
    paddingTop: '56.25%', // 16:9
  },
  actions: {
    display: 'flex',
  },
   expand: {
    transform: 'rotate(0deg)',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
    marginLeft: 'auto',
    [theme.breakpoints.up('sm')]: {
      marginRight: -8,
    },
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  avatar: {
    backgroundColor: red[500],
  },
    cardHover: {
        marginTop: "30px",
        width: "100%",
        margin: "25px 0",
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.14)",
        borderRadius: "3px",
        color: "rgba(0, 0, 0, 0.87)",
        background: "#AAA"
    },
    cardAvatar: {
        maxWidth: "130px",
        maxHeight: "130px",
        borderRadius: "50%",
        overflow: "hidden",
        boxShadow:
            "0 10px 30px -12px rgba(0, 0, 0, 0.42), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)"
    },


    textAlign: {
        textAlign: "center"
    },
    cardSubtitle: {
        color: "#999",
        fontSize: "1em",
        textTransform: "uppercase",
        marginTop: "10px",
        marginBottom: "10px"
    },
    cardTitle: {
        fontSize: "1.3em",
        marginTop: "10px",
        marginBottom: "10px"
    },
    cardDescription: {
        padding: "5px 10px",
    },
    cardActions: {
        height: "auto",
        display: "inline"
    },
    mm: {
         fontSize: "20px",
         fontWeight: 'bold'
    }
});

class Event extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            deleteStatus: false,
            deleteError: false,
            redirect: false,
            updateRequest: false,
            bgColor: props.bg,
        };
    }

    render() {
        const { classes } = this.props;
        //console.log(this.props.data);
        var {
                id,
                date,
                description,
                location,
                name,
                images,
                contacts,
                payments
            } = this.props.data;
        // var obj = [];
        // var ary = [];
        // var a=0;
         var b=0;
        // var aid = this.props.id;
        // paymentsRef.where('eventId', '==', this.props.id).get()
        //     .then((querySnapshot) => {
        //         querySnapshot.forEach((doc) => {
        //         // doc.data() is never undefined for query doc snapshots
        //         // let eventDatas = {
        //         //     //id: doc.id,
        //         //     data: doc.data(),
        //         // }
        //         // datas.push(doc.data());
        //         //a += parseInt(doc.data().amount);
        //         // datas.push(a);       
        //         //b=a; 
        //         obj[aid] = doc.data().amount
        //         ary.push(obj);
        //         //console.log(eventDatas); 
        //         }); 
        // });
        // console.log(ary); 

        var date1 = new Date(date);
        var date2 = new Date();
        var timeDiff = Math.abs(date2.getTime() - date1.getTime());
        var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24)); 

        var updateId = "/events/details/" + this.props.id;

        if (this.state.redirect) {
            return (
                <Redirect to={'/sudo/events'} />
            );
        }
        
        if (this.state.updateRequest) {
            return (
                <Redirect to={{pathname: updateId, bg: this.state.bgColor}} />
            );
        }
        
        if (images[0]==null) {
            var img="http://orioninfosolutions.org/rkbaaz/img.png";
        }
        else
        {
            var img=images[0].url;
        }
        if (contacts) { var con=contacts.length} else{ var con=0;}


        return (
            <Tooltip title='Click to update or view details'>
                <Card style={{ background: this.state.bgColor }} onClick={() => this.setState({ updateRequest: true })} className={classes.card} >
                     <CardHeader
            avatar={
            <Avatar aria-label="Recipe" className={classes.avatar}>
            {diffDays}
            </Avatar>
            }
            action={
            <IconButton>
              <MoreVertIcon />
            </IconButton>
            }
            title= {name}
            subheader={date}
            />
            <CardMedia
            className={classes.media}
            image={img}
            title= {name}
            />
            <BottomNavigation
            value='wewe'
            onChange={this.handleChange}
            showLabels
            className={classes.boot}
            >
            <BottomNavigationAction className={classes.mm} label="Invited" icon={con} />
            <BottomNavigationAction className={classes.mm} label="Raised" icon={b} />
            <BottomNavigationAction className={classes.mm} label="RSVP'ed" icon={'34'} />
            </BottomNavigation>
                 
                </Card >
            </Tooltip>
        );
    }
}

Event.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Event);



// WEBPACK FOOTER //
// ./src/components/Events/Event.js